import { defineMessages } from 'react-intl';

export const messages: {
    title: {
        id: string;
        defaultMessage: string;
        description: string;
    }; description: {
        id: string;
        defaultMessage: string;
        description: string;
    }; itemsCountLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; showMoreButton: {
        id: string;
        defaultMessage: string;
        description: string;
    }; showLessButton: {
        id: string;
        defaultMessage: string;
        description: string;
    }; suggestedAppsTitle: {
        id: string;
        defaultMessage: string;
        description: string;
    }; suggestedAppsDescription: {
        id: string;
        defaultMessage: string;
        description: string;
    }; teammatesUsingLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; connectButton: {
        id: string;
        defaultMessage: string;
        description: string;
    }; allConnectorsButton: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	title: {
		id: 'twg-microsite-experience.v2.connectedApps.title',
		defaultMessage: 'Your Teamwork Graph Ecosystem',
		description: 'Heading for the connected apps section',
	},
	description: {
		id: 'twg-microsite-experience.v2.connectedApps.description',
		defaultMessage: 'We’re building your context from these {appCount} apps',
		description: 'Description for the connected apps section about apps connected',
	},
	itemsCountLabel: {
		id: 'twg-microsite-experience.v2.connectedApps.itemsCountLabel',
		defaultMessage: '{count} items',
		description: 'Number of items from a connected app',
	},
	showMoreButton: {
		id: 'twg-microsite-experience.v2.connectedApps.showMoreButton',
		defaultMessage: 'Show {count} more',
		description: 'Button label to reveal hidden connected apps',
	},
	showLessButton: {
		id: 'twg-microsite-experience.v2.connectedApps.showLessButton',
		defaultMessage: 'Show less',
		description: 'Button label to collapse the hidden connected apps list',
	},
	suggestedAppsTitle: {
		id: 'twg-microsite-experience.v2.connectedApps.suggestedAppsTitle',
		defaultMessage: "Feel like something's missing?",
		description: 'Heading for the suggested apps upsell area',
	},
	suggestedAppsDescription: {
		id: 'twg-microsite-experience.v2.connectedApps.suggestedAppsDescription',
		defaultMessage: 'Connect more apps to deepen your AI context.',
		description: 'Description for the suggested apps upsell area',
	},
	teammatesUsingLabel: {
		id: 'twg-microsite-experience.v2.connectedApps.teammatesUsingLabel',
		defaultMessage: '{count} teammates using',
		description: 'Number of teammates using a suggested app',
	},
	connectButton: {
		id: 'twg-microsite-experience.v2.connectedApps.connectButton',
		defaultMessage: 'Connect',
		description: 'Button label to connect a suggested app',
	},
	allConnectorsButton: {
		id: 'twg-microsite-experience.v2.connectedApps.allConnectorsButton',
		defaultMessage: 'See all connectors',
		description: 'Button label to see all connectors',
	},
});
